
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import WenfangPopup from './WenfangPopup.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { EnumLearnFreqType } from '@xt/client'
import moment from 'moment'
import { Observer } from 'mobx-vue'

type File = {
  name: string
  url: string
}

type GuideEntranceData = {
  coursePreparePcPic: string // 入口页左侧的背景图
  assistantUrl: string // 二维码图
  dayPlanWeek: string // 课程安排进行时间
  dayPlanDay: string // 课程安排上课时间
  playBack: number // 回放有效期时间
  file: File[] // 文档名称
  dayText: string // 日期文字
  timeText: string // 时间文字
  isAfternoon: boolean // 是否是下午
  curriculumUrl: string // 课程表图片
}

@Observer
@Component({
  components: {
    LazyImg,
    WenfangPopup
  }
})
export default class extends Vue {
  @Prop({ type: Boolean, default: false }) visible: boolean

  data: GuideEntranceData = {
    coursePreparePcPic: '',
    assistantUrl: '',
    dayPlanWeek: '',
    dayPlanDay: '',
    dayText: '',
    timeText: '',
    isAfternoon: false,
    playBack: 0,
    file: [
      {
        name: '',
        url: ''
      }
    ],
    curriculumUrl: ''
  }

  // true-为大屏样式，false为小屏样式
  layout: boolean = false
  // 当前的slide index
  current: 0 | 1 = 0

  handleNext() {
    this.current = 1
  }

  handlePre() {
    this.current = 0
  }

  @Watch('visible')
  handleVisibleChange(isVisible: boolean) {
    if (isVisible) {
      // 清除旧数据
      this.data.dayPlanWeek = ''
      this.data.dayPlanDay = ''

      if (this.$store.$courseV2.courseInfo) {
        // 设置入口页左侧的背景图
        this.data.coursePreparePcPic = this.$store.$courseV2.courseInfo.coursePreparePcPic
        // 设置上课频率
        const [dayPlanWeek, dayPlanDay] = this.formatDayPlan(this.$store.$courseV2.courseInfo.learnFreqType)
        this.data.dayPlanWeek = dayPlanWeek
        this.data.dayPlanDay = dayPlanDay
        // 设置回放有效期
        this.data.playBack = this.$store.$courseV2.courseInfo.defaultPlaybackDuration
        if (this.$store.$courseV2.mapInfo) {
          const classhour = this.$store.$courseV2.mapInfo.classhourList.filter(item => item.classhourType === 1)
          // 设置第一时间
          const { dayText, timeText, isAfternoon } = this.firstCourseTimeformat(classhour[0].startTime)
          this.data.dayText = dayText
          this.data.timeText = timeText
          this.data.isAfternoon = isAfternoon
        }
      }

      if (this.$store.$courseV2.productInfo) {
        this.data.curriculumUrl = this.$store.$courseV2.productInfo.curriculumUrl
      }
    }
  }

  formatDayPlan(learnFreqType: EnumLearnFreqType): [string, string] {
    switch (learnFreqType) {
      case EnumLearnFreqType.THE_WEEK_SATURDAY:
        return ['每周', '周六']
      case EnumLearnFreqType.THE_WEEK_SUNDAY:
        return ['每周', '周日']
      case EnumLearnFreqType.EVERY_OTHER_WEEK_SATURDAY:
        return ['隔周', '周六']
      case EnumLearnFreqType.EVERY_OTHER_WEEK_SUNDAY:
        return ['隔周', '周日']
      default:
        return ['', '']
    }
  }

  // 第一课时间处理
  firstCourseTimeformat = (
    timestamp: number
  ): {
    dayText: string
    timeText: string
    isAfternoon: boolean
  } => {
    // 创建Moment对象
    const momentObj = moment(timestamp)

    // 1. 获取"6月20日"格式的日期
    const dayText = momentObj.format('M月D日') // "6月20日"

    // 2. 判断是上午还是下午
    const isAfternoon = momentObj.hour() >= 12 // true/false

    // 3. 获取"9:00"格式的时间
    const timeText = momentObj.format('H:mm') // "9:00"

    return {
      dayText,
      timeText,
      isAfternoon
    }
  }

  get StatisticsData() {
    return this.$store.$courseV2.StatisticsData
  }

  handleToBook(book: number) {
    window.open(`/books?file=book-0${book}`)
  }

  // 添加窗口监听
  addWindowResize() {
    if (window.innerHeight - 64 >= 872) {
      this.layout = true
    } else {
      this.layout = false
    }
  }
  // 显示课程表
  openSchedule() {
    if (this.$store.$courseV2.productInfo) {
      this.$showViewer(this.$store.$courseV2.productInfo.curriculumUrl)
    }
  }

  /** TODO1：课程表旋转呈现
   * 缩放并截取图片
   */
  getImageUrl(url: string): string {
    return `${url}?x-oss-process=image/resize,w_352,m_lfit,limit_0/crop,w_352,h_386,g_nw/quality,q_90/interlace,1`
  }

  @Emit('close')
  onClose() {}

  @Emit('drive')
  onDrive() {}

  @Emit('open-joinclass')
  openJoinClass() {}

  // 生命周期钩子
  created(): void {}

  mounted(): void {
    // 首次执行
    this.addWindowResize()
    // 绑定监听事件
    window.addEventListener('resize', this.addWindowResize)
  }

  updated(): void {}

  destroyed(): void {}
}
